import { selectorFamily } from "recoil";

import { SortingEnum } from "../../enums";
import { hasKeys } from "../../helpers";
import {
  reportsTableColumnsSizingAF,
  reportsTableColumnsSortingAF,
} from "../atoms";

export const reportsTableColumnSortingSF = selectorFamily<
  SortingEnum,
  [reportId: number, fieldNameResolved: string]
>({
  key: "reportsTableColumnSortingSF",
  get:
    ([reportId, fieldNameResolved]) =>
    ({ get }) => {
      const columnSorting = get(reportsTableColumnsSortingAF(reportId));
      const isSorted =
        columnSorting?.length && columnSorting?.[0].id === fieldNameResolved;

      if (!isSorted) {
        return SortingEnum.NotSorted;
      }

      if (columnSorting[0].desc) {
        return SortingEnum.Desc;
      }

      return SortingEnum.Asc;
    },
});

export const reportsTableColumnWidthSF = selectorFamily<
  number | undefined,
  [reportId: number, columnId: string]
>({
  key: "reportsTableColumnWidthSF",
  get:
    ([reportId, columnId]) =>
    ({ get }) =>
      get(reportsTableColumnsSizingAF(reportId))[columnId],
});

export const isReportsTableColumnsSizedSF = selectorFamily<boolean, number>({
  key: "isReportsTableColumnsSizedSF",
  get:
    reportId =>
    ({ get }) =>
      hasKeys(get(reportsTableColumnsSizingAF(reportId))),
});
